// Delegation drawer (embedded chat in a narrow Sheet) styles (WEB-8002).
// Composed last by workspaceStyles.ts — it overrides chat sections by source
// order. See components/DelegationDrawer.tsx for the ai-ws class rationale.
export const chatDelegationDrawer = `
/* ===== Delegation drawer (embedded chat in a narrow Sheet) ===== */
/* No horizontal scrollbar in the drawer — the chat scroller's inline
   overflow:auto otherwise shows a spurious x-bar from sub-pixel/decorative
   overflow. Content adapts to the width instead (tables reflow below). */
.ws-embedded-drawer .ws-chat-body > div { overflow-x: hidden !important; }
/* Tables: fit the drawer width and wrap cell content instead of scrolling
   horizontally (overrides the main chat's display:block; overflow-x:auto). */
.ws-embedded-drawer .pr-prose table { display: table; width: 100%; overflow-x: hidden; }
.ws-embedded-drawer .pr-prose th,
.ws-embedded-drawer .pr-prose td { white-space: normal; overflow-wrap: anywhere; }
`;
